import type {
    NCoreUIKitIcon
} from "ncore-ui-kit";

const createSampleIcon = (paths: Array<string>): NCoreUIKitIcon => {
    const SampleIcon: NCoreUIKitIcon = ({
        customColor,
        size
    }) => <svg
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke={customColor}
        viewBox="0 0 24 24"
        strokeWidth={2}
        height={size}
        width={size}
        fill="none"
    >
        {
            paths.map((path) => <path
                key={path}
                d={path}
            />)
        }
    </svg>;

    return SampleIcon;
};

export const PlusIcon = createSampleIcon([
    "M5 12h14",
    "M12 5v14"
]);

export const CheckIcon = createSampleIcon([
    "M20 6 9 17l-5-5"
]);

export const ChevronRightIcon = createSampleIcon([
    "m9 18 6-6-6-6"
]);

export const SearchIcon = createSampleIcon([
    "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    "m21 21-4.3-4.3"
]);

export const BellIcon = createSampleIcon([
    "M10.268 21a2 2 0 0 0 3.464 0",
    "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
]);

export const UserIcon = createSampleIcon([
    "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
    "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
]);

export const HomeIcon = createSampleIcon([
    "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
    "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
]);

export const StarIcon = createSampleIcon([
    "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
]);

export const HeartIcon = createSampleIcon([
    "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
]);

export const InfoIcon = createSampleIcon([
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z",
    "M12 16v-4",
    "M12 8h.01"
]);

export const FileIcon = createSampleIcon([
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
    "M14 2v4a2 2 0 0 0 2 2h4"
]);
